/* eslint-disable @typescript-eslint/no-var-requires */
import React, {
  FunctionComponent,
  MutableRefObject,
  useEffect,
  useRef,
} from 'react';

import './animation009.less';
import { usePlayFlag } from './../../components/topicScroll';
import ImgPoint from '../../../../../assets/animation_point.gif';

interface IAnimation009Item {
  icon: string;
  color: string;
  text: string;
}

interface IAnimation009Props {
  items: IAnimation009Item[];
  onCompleted: () => void;
}

const Animation009: FunctionComponent<IAnimation009Props> = ({
  items,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const startPlay = (next = 2) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      console.log('Animation009 onCompleted');
      onCompleted && onCompleted();
    }
  };
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;

  useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };
  return (
    <div ref={crrRef} className="animation009 component" style={{ margin: 0 }}>
      <img
        className="click-point"
        onClick={() => clickToPlay()}
        style={{
          display: play <= 1 ? 'block' : 'none',
        }}
        src={ImgPoint}
        alt=""
      />
      <div className="animation009-content">
        {items.map((itm: IAnimation009Item, idx: number) => (
          <div
            key={idx}
            className={`animation009-item animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            style={{
              width: `${(1 / items.length) * 100}%`,
              color: itm.color,
            }}
          >
            <div className="animation009-indicate">
              <div
                className="animation009-icon"
                style={{ backgroundColor: itm.color }}
              >
                <img src={getImg(itm.icon)} alt="" />
              </div>
              <div className="animation009-indicate-number">0{idx + 1}</div>
            </div>
            <div
              className="animation009-text"
              dangerouslySetInnerHTML={{ __html: itm.text }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Animation009;
